
export const fencePaint = {
    'line-color': '#511A3F', // dark purple (moving layers main color)
    "line-width": 2,
};

export const positionCirclePaint = {
    'line-color': '#7CFC00', // lawngreen
    'line-width': 2
};

export const positionCircleFillPaint = {
    'fill-color': '#7CFC00',
    'fill-opacity': 0.7
};

export const positionCirclePaintInsideFence = {
    'line-color': 'red',
    'line-width': 2
};

export const positionCircleFillPaintInsideFence = {
    'fill-color': 'red',
    'fill-opacity': 0.7
};

export const positionCirclePaintInaccurate = {
    'line-color': 'blue',
    'line-width': 2,
    'line-blur': 4
};

export const positionCircleFillPaintInaccurate = {
    'fill-color': 'blue',
    'fill-opacity': 0.7
};